/**
 * Spells a fiscal address as `2025/2026 W04`: the fiscal year label and the
 * week's number within that year. Both come from the calendar (the API's
 * `FiscalWeek`, or `weekPeriodMapping`), never from arithmetic on the ISO key.
 */
export function formatFiscalWeek(
  fiscalYear: string,
  weekOfYear: number
): string {
  return `${fiscalYear} W${String(weekOfYear).padStart(2, "0")}`;
}
